/**
 * Shared constants + small presentational bits for the public product page.
 */
import { ShieldCheck, X } from "@phosphor-icons/react";
import { fmt } from "@/lib/api";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;


export const PUB = `${BACKEND}/api/public`;

// Read the post that drove this visit (set during ?p= capture). Persisted
// per-product in sessionStorage so it survives the Stripe redirect roundtrip.


export function getSourcePostId(productId) {
  if (!productId || typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(`vendeia_src_post_${productId}`) || null;
  } catch {
    return null;
  }
}


export function PaymentBanner({ status, onClose, moneda }) {
  const cfg = {
    checking: { bg: "#FFF9E6", color: "#B45309", border: "#FFCC00" },
    processing: { bg: "#E3F2FD", color: "#0D47A1", border: "#1E4FCC" },
    paid: { bg: "#E8F5E9", color: "#1B5E20", border: "#00C853" },
    failed: { bg: "#FFEBEE", color: "#B71C1C", border: "#FF2A00" },
    cancelled: { bg: "#FFEBEE", color: "#B71C1C", border: "#FF2A00" },
  }[status.state] || { bg: "#F4F4F5", color: "#09090B", border: "#E4E4E7" };

  return (
    <div
      className="border-b"
      style={{ background: cfg.bg, borderColor: cfg.border }}
      data-testid={`payment-banner-${status.state}`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 text-sm" style={{ color: cfg.color }}>
          {status.state === "paid" ? (
            <ShieldCheck size={20} weight="fill" />
          ) : status.state === "checking" || status.state === "processing" ? (
            <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
          ) : (
            <X size={20} weight="bold" />
          )}
          <div>
            <div className="font-semibold">{status.message}</div>
            {status.state === "paid" && status.amount_total && (
              <div className="text-xs opacity-80">
                Total cobrado: {fmt((status.amount_total || 0) / 100, (status.currency || moneda).toUpperCase())} · Folio{" "}
                <span className="font-mono">{status.sale_id?.slice(0, 8)}</span>
              </div>
            )}
          </div>
        </div>
        <button onClick={onClose} className="p-1 hover:bg-black/5" data-testid="banner-close">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}


export function Trust({ icon, title }) {
  return (
    <div className="border-r border-b border-zinc-200 p-3 text-center">
      <div className="text-klein flex justify-center">{icon}</div>
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted2 mt-1">{title}</div>
    </div>
  );
}


export function Field({ label, children }) {
  return (
    <div>
      <label className="overline block mb-1.5">{label}</label>
      {children}
    </div>
  );
}


export function SocialLink({ handle, base, label, testid }) {
  // Accepts handles like "@mininegocio", "minegocio", or full https URLs.
  const isUrl = /^https?:\/\//i.test(handle);
  const clean = (handle || "").replace(/^@/, "").trim();
  const href = isUrl ? handle : `${base}${clean}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1 px-3 py-1.5 border border-zinc-200 text-xs font-medium hover:bg-zinc-50"
      data-testid={testid}
    >
      {label} · @{clean.split("/").pop()}
    </a>
  );
}
